import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import FormInputBase from './FormInputBase'

const FormCheckbox = ({ formProps, inputConfig, itemProps }) => {
  const { label, disabled } = itemProps || {}
  const { onSubmit, inputProps } = inputConfig || {}
  const { field: { value, name, onChange } = {}, fieldState: { error } = {} } = formProps || {}

  return (
    <FormInputBase
      error={error}
      onSubmit={
        onSubmit
          ? () => {
              onSubmit(value)
            }
          : null
      }
      inputProps={inputProps}
    >
      <FormControlLabel
        key={`chkbx_${name}}`}
        value={value}
        label={label}
        control={<Checkbox checked={value} onChange={onChange} disabled={disabled} />}
      />
    </FormInputBase>
  )
}

export default FormCheckbox
